export default __webpack_public_path__ + "static/media/audio-teaser-play.330d28b8.svg";